import { Component } from '@angular/core';

@Component({
  selector: 'app-about-enterprise',
  templateUrl: './about-enterprise.component.html',
  styleUrls: ['./about-enterprise.component.scss']
})
export class AboutEnterpriseComponent {
  selectedItem = 'calendarItem';

}
